// fetch orders
export const getOrdersInit = 'GET_ORDERS_INIT';
export const getOrdersSuccess = 'GET_ORDERS_SUCCESS';
export const getOrdersError = 'GET_ORDERS_ERROR';
